/**
 * Image lightbox with prev/next + Esc. PDFs open in a new tab instead of inline.
 */
import { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Lightbox.module.css';

export function Lightbox({ images, index, onClose, onIndex }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onIndex((index + 1) % images.length);
      if (e.key === 'ArrowLeft') onIndex((index - 1 + images.length) % images.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [index, images.length, onClose, onIndex]);

  if (index == null || !images[index]) return null;
  const current = images[index];

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <button className={styles.close} onClick={onClose} aria-label="Close">
        <X size={24} />
      </button>
      {images.length > 1 && (
        <button
          className={`${styles.nav} ${styles.prev}`}
          onClick={(e) => {
            e.stopPropagation();
            onIndex((index - 1 + images.length) % images.length);
          }}
          aria-label="Previous"
        >
          <ChevronLeft size={28} />
        </button>
      )}
      <figure className={styles.figure} onMouseDown={(e) => e.stopPropagation()}>
        <img src={current.url} alt={current.label || 'Document'} />
        {current.label && <figcaption>{current.label}</figcaption>}
      </figure>
      {images.length > 1 && (
        <button
          className={`${styles.nav} ${styles.next}`}
          onClick={(e) => {
            e.stopPropagation();
            onIndex((index + 1) % images.length);
          }}
          aria-label="Next"
        >
          <ChevronRight size={28} />
        </button>
      )}
    </div>
  );
}

export default Lightbox;
